<template>
	<fragment>
		<common-header
			subname="사이트관리"
			name="로그 관리"
			v-bind:searchbox="true"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			@keywordChanged="searchByKeyword"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu></common-side-menu>
			<!-- //end .side-nav -->
			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">로그 관리</div>
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<select class="form-control round pull-left m-r-5" @change="changeLogKeepingPeriod" v-model="logKeepingPeriod">
								<option value="1">1개월</option>
								<option value="6">6개월</option>
								<option value="12">12개월</option>
								<option value="24">24개월</option>
							</select>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#" @click="excelDownload">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
				</div>
				
				<div class="btn-group-box clearfix">
					<table class="table2 table-hover text-center">
						<thead>
							<tr class="bg-lightgray">
								<!--th>
									<input id="table-allcheck" class="checkbox" type="checkbox" :checked="allSelected" @change="selectAll">
									<label for="table-allcheck">체크버튼</label>
								</th-->
								<th class="w20">#</th>
								<th class="w20">요청자ID</th>
								<th class="w20">METHOD</th>
								<th class="w100">URL</th>
								<th class="w40">IP</th>
								<th class="w40">작성일</th>
							</tr>
						</thead>
						<tbody v-for="(log, idx) in logList" :key="`log-id-${log.requstId}`">
							<tr class="margin">
								<td colspan="7"></td>
							</tr>
							<tr>
								<td>
									{{totalCount - offset - idx}}
								</td>
								<td>
									{{log.rqesterId}}
								</td>
								<td>
									{{log.requstMethod}}
								</td>
								<td>
									{{log.url}}
								</td>
								<td>
									{{log.rqesterIp}}
								</td>
								<td>
									{{log.occrrncDe}}
								</td>
							</tr>
						</tbody>
					</table>

					<ctrl-pagination :currentPage="offset / pageSize + 1"
						:pageSize="pageSize" :totalCount="totalCount"
						:key="hash({pageSize, offset, totalCount})"
						@pageChanged="onPageChanged"></ctrl-pagination>
				</div>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명칭
	name: "ViewLogList",
	mixins: [fnAdjustHeight],
	mounted: function() {
		this.getLogList();
	},
	// 이 컴포넌트에서 사용할 자식컴포넌트
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		CtrlPagination,
		ModalConfirm,
		ModalAlert
	},

	// 이 컴포넌트에서 사용할 내부데이터
	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},
			menus: [
				{name: '사이트항목 목록', link: "/site", selected: false},
				{name: '로그 관리', link: "/log", selected: true},
			],
			buttons: [
				// {name: '사이트항목 작성', fn: () => {
				// 	if(!this.$route.params.boardId) {
				// 		this.modals.ModalAlert.msg = "게시판을 선택해 주세요";
				// 		this.modals.ModalAlert.show = true;
				// 	}
				// 	else this.$router.push(`/site/${this.$route.params.boardId}/write`);
				// }},
				// {name: '사이트 만들기', fn: () => {
				// 	this.$router.push("/site/register");
				// }},
			],
			server,
			link: "",
			sideButtons: [],
			sideMenus: [],
			logList: [],
			articles: [],
			keyword: this.$route.query.keyword || "",
			totalCount: 0,
			pageSize: 30,
			offset: 0,
			logKeepingPeriod : 12,
		}
	},

	// 이 컴포넌트에서 구현할 기능
	methods: {
		getLogList: async function() {
			try {
				//전자정부 pageSize는 pagination 보이는 갯수임
				const pageSize = 5;
				const pageUnit = this.pageSize;
				const pageIndex = (this.offset / pageUnit) + 1;
				const {data} = await Axios.post(`${server.addr()}${server.api.LOG}`,{
					pageSize, pageUnit, pageIndex
				})
				this.logList = data.resultList;
				this.totalCount = parseInt(data.resultCnt);
				this.offset = (parseInt(data.paginationInfo.currentPageNo) -1 )*this.pageSize;

			} catch(e) {e}	
		},
		searchByKeyword: function(keyword) {
			this.offset = 0;
			this.keyword = keyword;
			this.getArticles()
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;
			this.getLogList();
		},
		excelDownload: function() {
			Axios.post(server.addr()+server.api.LOG_EXCEL,{
				period : this.logKeepingPeriod
			}).then( response => {
				window.open( "/download/"+response.data, "", "" );
			})
		},
		changeLogKeepingPeriod : function(){
			console.log(this.logKeepingPeriod);
			// Axios.post(server.addr()+server.api.LOG_EXCEL).then( response => {
			// 	window.open( "/download/"+response.data, "", "" );
			// })
		}
	},
	computed: {
		allSelected: function() {
			const isAllSelected = this.articles.reduce((prev, curr) => prev && curr.selected , true);
			return isAllSelected;
		}
	}
}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}

.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>
